import {
  FEATURE_KEY_ACTIVITY_FEED,
  FEATURE_KEY_MEMBER_DIRECTORY
} from "../feature/constants"

export const COMMUNITY_AREA_DISCUSSION = "discussion"
export const COMMUNITY_AREA_MEMBERS = "members"
export const COMMUNITY_AREA_ACTIVITY = "activity"

export const COMMUNITY_FEATURE_VISIBILITY_MAP = {
  // no CFP mapping for COMMUNITY_AREA_DISCUSSION for now
  [COMMUNITY_AREA_DISCUSSION]: null,
  [COMMUNITY_AREA_MEMBERS]: FEATURE_KEY_MEMBER_DIRECTORY,
  [COMMUNITY_AREA_ACTIVITY]: FEATURE_KEY_ACTIVITY_FEED
}
